<template>
  <div class="home-container">

    <!-- 第一页：英雄区域 -->
    <section id="hero" class="page-section hero-section">
      <div class="home-bg"></div>
      <div class="content-overlay">
        <div class="title-section">
          <h1>专业电力建设解决方案</h1>
          <h2>引领能源未来</h2>
        </div>
        <div class="intro-section">
          <p>华洲电力建设有限公司专注于电力工程建设、设计与运维，为客户提供全方位的电力解决方案，以专业技术和卓越服务赢得行业赞誉。</p>
        </div>
        <div class="buttons-section">
          <el-button class="action-button custom-primary-btn" @click="$router.push('/product')">查看工程案例</el-button>
          <el-button class="action-button custom-primary-btn" @click="$router.push('/cooperative')">了解主营业务</el-button>
        </div>
      </div>
    </section>

    <!-- 第二页：公司简介 -->
    <section id="about" class="page-section about-section">
      <div class="section-content">
        
        <div class="about-content">
          <div class="about-text">
            <div class="section-header">
                <h2>关于华洲电力</h2>
                <p>华洲电力建设有限公司成立于2019年4月，是一家专注于电力工程施工、新能源工程管理与建设的现代化建筑企业。</p>
            </div>
            <div class="header-line"></div>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;华洲电力建设有限公司位于湖南湘乡经济开发区大将北路30号，注册资本10158万元人民币。公司获得国家能源局湖南监管办公室颁发的电力设施许可证承装二级、承修二级、承试二级资质，省住建厅颁发的《安全生产许可证》、施工总承包电力工程资质、专业承包消防设施工程资质等多项资质。取得了ISO9001质量管理体系认证证书、ISO14001环境管理体系认证证书、ISO45001职业健康安全管理体系认证证书。自成立以来连续多年获得湖南省信用等级AAA企业、湘潭市守合同重信用单位、湖南省合同重信用单位等称号。<br>&nbsp;&nbsp;&nbsp;&nbsp;华洲电建以"以质量赢信誉，以信誉赢市场"的经营思想，采用抱团组织、分享机制、发展机制，提供共同、共享、共赢的大空间平台。目前公司业务已进驻湖南、广东、广西、贵州、江西、重庆、福建、安徽、黑龙江、湖北、内蒙古、宁夏、海南等省份，并开设了多家分公司及办事处。</p>
            
            <!-- 统计数据 -->
            <div class="stats-container" style="display: flex; justify-content: space-between; width: 100%;">
              <div class="stat-item" style="flex: 1; text-align: center; margin: 0 10px;">
                <span class="stat-number">500+</span>
                <span class="stat-label">完成项目</span>
              </div>
              <div class="stat-item" style="flex: 1; text-align: center; margin: 0 10px;">
                <span class="stat-number">30+</span>
                <span class="stat-label">行业奖项</span>
              </div>
              <div class="stat-item" style="flex: 1; text-align: center; margin: 0 10px;">
                <span class="stat-number">1200+</span>
                <span class="stat-label">专业团队</span>
              </div>
              <div class="stat-item" style="flex: 1; text-align: center; margin: 0 10px;">
                <span class="stat-number">30+</span>
                <span class="stat-label">覆盖省市</span>
              </div>
            </div>
            
            <a href="javascript:void(0)" @click="$router.push('/about')" class="learn-more-link">了解更多公司信息 →</a>
          </div>
          <div class="about-image">
            <img src="@/assets/001.jpg" alt="公司大楼" />
          </div>
        </div>
        <!-- 高压线路图片 -->
        <div style="position: absolute; bottom: 0; left: 0;">
          <img src="@/assets/gaoyaxian.png" alt="高压线路" style="width: auto; height: auto;" />
        </div>
      </div>
    </section>

    <!-- 第三页：主营业务 -->
    <section id="business" class="page-section business-section">
      <div class="section-content-bussiness" style="display: flex; flex-direction: row;">
        <!-- 左侧蓝色区域 -->
        <div style="background-color: #3f60f2; color: white; padding: 40px 30px; max-width: 300px; display: flex; flex-direction: column; justify-content: center; height: 100%;">
          <h2 style="margin-top: 50px;font-size: 1.5rem; margin-bottom: 20px;font-weight: 500;">主营业务</h2>
          <p style="margin-bottom: 60px; line-height: 1.6;font-size: 0.8rem;font-weight: lighter;">我们提供全方位电力解决方案。从设计咨询到工程施工到运维服务，满足客户多样化需求。</p>
          <div class="white-line"></div>
          <p style="margin-top: 20px; margin-bottom: 30px; line-height: 1.6;font-size: 1.0rem;">已涉及电力工程建设、电力工程设计、建筑工程、城市道路照明工程、房地产开发、水利水电工程等众多领域。</p>
          <a href="javascript:void(0)" @click="$router.push('/cooperative')" style="text-decoration: none;color: white; font-size: 0.8rem;font-weight: lighter;">了解更多公司信息 →</a>
        </div>
        
        <!-- 右侧业务卡片 -->
        <div style="flex: 1; width: 100%; height: 100%;">
          <div class="business-cards" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 0; width: 100%; height: 100%; border-radius: 0;">
            <div class="business-card" style="text-align: center; width: 100%; height: 100%; position: relative; overflow: hidden; margin: 0; padding: 0;">
              <div class="card-image" style="width: 100%; height: 100%;">
                <img src="@/assets/business1.png" alt="输变电工程" style="width: 100%; height: 100%; object-fit: cover; margin: 0; padding: 0;" />
              </div>
              <h3 style="font-size: 1.1rem; position: absolute; bottom: 0; left: 0; width: 100%; margin: 0; padding: 10px; color: white; z-index: 1;">输变电工程</h3>
            </div>
            <div class="business-card" style="text-align: center; width: 100%; height: 100%; position: relative; overflow: hidden; margin: 0; padding: 0;">
              <div class="card-image" style="width: 100%; height: 100%;">
                <img src="@/assets/business2.png" alt="地基基础工程" style="width: 100%; height: 100%; object-fit: cover; margin: 0; padding: 0;" />
              </div>
              <h3 style="font-size: 1.1rem; position: absolute; bottom: 0; left: 0; width: 100%; margin: 0; padding: 10px; color: white; z-index: 1;">地基基础工程</h3>
            </div>
            <div class="business-card" style="text-align: center; width: 100%; height: 100%; position: relative; overflow: hidden; margin: 0; padding: 0;">
              <div class="card-image" style="width: 100%; height: 100%;">
                <img src="@/assets/business3.png" alt="消防设施工程" style="width: 100%; height: 100%; object-fit: cover; margin: 0; padding: 0;" />
              </div>
              <h3 style="font-size: 1.1rem; position: absolute; bottom: 0; left: 0; width: 100%; margin: 0; padding: 10px; color: white; z-index: 1;">消防设施工程</h3>
            </div>
            <div class="business-card" style="text-align: center; width: 100%; height: 100%; position: relative; overflow: hidden; margin: 0; padding: 0;">
              <div class="card-image" style="width: 100%; height: 100%;">
                <img src="@/assets/business4.png" alt="防水防腐保温工程" style="width: 100%; height: 100%; object-fit: cover; margin: 0; padding: 0;" />
              </div>
              <h3 style="font-size: 1.1rem; position: absolute; bottom: 0; left: 0; width: 100%; margin: 0; padding: 10px; color: white; z-index: 1;">防水防腐保温工程</h3>
            </div>
            <div class="business-card" style="text-align: center; width: 100%; height: 100%; position: relative; overflow: hidden; margin: 0; padding: 0;">
              <div class="card-image" style="width: 100%; height: 100%;">
                <img src="@/assets/business_h5.png" alt="电力工程施工总承包" style="width: 100%; height: 100%; object-fit: cover; margin: 0; padding: 0;" />
              </div>
              <h3 style="font-size: 1.1rem; position: absolute; bottom: 0; left: 0; width: 100%; margin: 0; padding: 10px; color: white; z-index: 1;">电力工程施工总承包</h3>
            </div>
            <div class="business-card" style="text-align: center; width: 100%; height: 100%; position: relative; overflow: hidden; margin: 0; padding: 0;">
              <div class="card-image" style="width: 100%; height: 100%;">
                <img src="@/assets/business_h6.png" alt="起重设备安装工程" style="width: 100%; height: 100%; object-fit: cover; margin: 0; padding: 0;" />
              </div>
              <h3 style="font-size: 1.1rem; position: absolute; bottom: 0; left: 0; width: 100%; margin: 0; padding: 10px; color: white; z-index: 1;">起重设备安装工程</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四页：工程案例 -->
    <section id="cases" class="page-section cases-section" :style="{ backgroundImage: `url(${currentBackgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '120px 0', position: 'relative' }">
      <!-- 半透明背景遮罩 -->
      <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 0;"></div>
      
      <div class="container" style="position: relative; z-index: 1; ">
        <div style="text-align: left;">
          <h2 style="color: white; font-size: 1.5rem; margin-bottom: 15px; text-align: left;">工程案例</h2>
          <p style="color: white; margin-bottom: 20px; text-align: left;">多年来，我们完成了众多重点电力工程项目，积累了丰富的经验，赢得了客户的广泛认可。</p>
          <div style="width: 50px; height: 3px; background-color: #a3b6fe; margin-bottom: 30px;"></div>
          <p style="color: white; margin-bottom: 40px; text-align: left;">已涉及电力工程建设、电力工程设计、建筑工程、城市道路照明工程、房地产开发、水利水电工程等众多领域。</p>
          <a href="javascript:void(0)" @click="$router.push('/product')" style="color: #a3b6fe; text-decoration: none; display: inline-block; margin-bottom: 40px; text-align: left;">了解更多工程案例 →</a>
        </div>
        
        <div style="max-width: 900px;display: flex;flex-wrap: wrap; justify-content: flex-start; margin-bottom: 100px;">
            <el-menu
                v-model="selectedIndex"
                default-active="1"
                class="el-menu-demo"
                mode="horizontal"
                background-color="#f0f0f0c9"
                text-color="#ffffff"
                active-text-color="#4262f3"
                @select="handleSelect"
                style="width: 100%; max-width: 580px;"
              >
                <el-menu-item index="1">变电站土建工程</el-menu-item>
                <el-menu-item index="2">配电工程</el-menu-item>
                <el-menu-item index="3">新能源工程</el-menu-item>
                <el-menu-item index="4">集电线路工程</el-menu-item>
            </el-menu>
        </div>
      </div>
    </section>

    <!-- 第五页：关于我们 -->
    <section id="about" class="page-section" :style="{ backgroundImage: `url(${require('@/assets/home_news_bg.png')})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '80px 0' }">
      <div class="container" style="position: relative; z-index: 1; max-width: 1200px; margin: 0 auto; padding: 0 20px;">
        <div style="display: flex;">
          <!-- 左侧标题和底部链接上下布局 -->
          <div style="width: 30%;">
            <div style="margin-bottom: 30px;">
              <h2 style="color: #2c3e50; font-size: 1.5rem; margin-bottom: 15px;font-weight: 500;">关于华洲电力</h2>
              <div style="width: 50px; height: 3px; background-color: #3f5ff0; margin: 0;margin-top: 80px;"></div>
              <p style="color: #666; margin-top: 20px;">了解公司最新动态、行业资讯及技术前沿</p>
            </div>
            
            <div style="margin-top: 220px;">
              <a href="javascript:void(0)" @click="$router.push('/news')" style="display: inline-flex; align-items: center; color: #3f5ff0; text-decoration: none;font-size: 0.8rem;">
                查看更多公司资讯
                <img src="@/assets/home_arrow.png" alt="箭头" style="width: 15px; height: 10px; margin-left: 10px; vertical-align: middle;" />
              </a>
            </div>
          </div>
          
          <!-- 右侧新闻卡片区域 - 单列垂直布局 -->
          <div style="width: 70%;">
            <!-- 新闻卡片容器 - 水平均匀分布 -->
            <div style="display: flex; justify-content: space-between;">
              <!-- 新闻卡片 1 -->
              <div style="width: 33.3%; background-color: white; border-bottom: 2px solid #3f5ff0;">
                <div style="padding: 15px;">
                  <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span style="font-size: 1.5rem; font-weight: bold; color: #3f5ff0;">08</span>
                    <span style="color: #666; font-size: 0.9rem;">2025.08.08</span>
                  </div>
                  <h3 style="color: #2c3e50; margin-bottom: 15px; font-size: 1rem; font-weight: normal;">华洲电力联普我国电力行业数字化转型发展趋势分析</h3>
                  <p style="color: #666; line-height: 1.6; font-size: 0.8rem; margin-bottom: 15px; height: 60px; overflow: hidden;">近日，随着数字技术的快速发展，电力行业正加速向数字化、智能化转型。本文从技术应用的技术蓬勃发展，科技壁垒一次次的被打破，现在的发展正以更快的速度进行发展...</p>
                  <img src="@/assets/news_h.png" alt="电力行业数字化" style="width: 100%; height: 150px; object-fit: cover; margin-bottom: 10px;" />
                  <a href="javascript:void(0)" @click="$router.push('/news')" style="color: #3f5ff0; text-decoration: none; display: inline-block; text-align: left; width: 100%;">
                    <img src="@/assets/home_border_arrow.png" alt="箭头" style="width: 30px; height: 30px; margin-left: 5px;" />
                  </a>
                </div>
              </div>
              
              <!-- 新闻卡片 2 -->
              <div style="width: 33.3%; background-color: white; border-bottom: 2px solid #3f5ff0;">
                <div style="padding: 15px;">
                  <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span style="font-size: 1.5rem; font-weight: bold; color: #3f5ff0;">08</span>
                    <span style="color: #666; font-size: 0.9rem;">2025.06.08</span>
                  </div>
                  <h3 style="color: #2c3e50; margin-bottom: 15px; font-size: 1rem; font-weight: normal;">华洲电力成功中标大型电网建设项目</h3>
                  <p style="color: #666; line-height: 1.6; font-size: 0.8rem; margin-bottom: 15px; height: 60px; overflow: hidden;">华洲电力建设有限公司近日成功中标某省大型电网建设项目，该项目总投资达5亿元，预计将在2023年底前完成建设。这标志着公司在电网建设领域的综合实力得到了市场的充分认可...</p>
                  <img src="@/assets/huikeshi.jpg" alt="电力行业数字化" style="width: 100%; height: 150px; object-fit: cover; margin-bottom: 10px;" />
                  <a href="javascript:void(0)" @click="$router.push('/news')" style="color: #3f5ff0; text-decoration: none; display: inline-block; text-align: left; width: 100%;">
                    <img src="@/assets/home_border_arrow.png" alt="箭头" style="width: 30px; height: 30px; margin-left: 5px;" />
                  </a>
                </div>
              </div>
              
              <!-- 新闻卡片 3 -->
              <div style="width: 33.3%; background-color: white; border-bottom: 2px solid #3f5ff0;">
                <div style="padding: 15px;">
                  <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                    <span style="font-size: 1.5rem; font-weight: bold; color: #3f5ff0;">08</span>
                    <span style="color: #666; font-size: 0.9rem;">2023.08.08</span>
                  </div>
                  <h3 style="color: #2c3e50; margin-bottom: 15px; font-size: 1rem; font-weight: normal;">公司召开2023年安全生产工作会议</h3>
                  <p style="color: #666; line-height: 1.6; font-size: 0.8rem; margin-bottom: 15px; height: 60px; overflow: hidden;">为进一步加强公司安全生产管理，提升全员安全意识，公司于近日召开了2023年安全生产工作会议。会议总结了过去一年的安全生产工作，并对新一年的安全生产任务进行了部署...</p>
                  <img src="@/assets/dating.jpg" alt="电力行业数字化" style="width: 100%; height: 150px; object-fit: cover; margin-bottom: 10px;" />
                  <a href="javascript:void(0)" @click="$router.push('/news')" style="color: #3f5ff0; text-decoration: none; display: inline-block; text-align: left; width: 100%;">
                    <img src="@/assets/home_border_arrow.png" alt="箭头" style="width: 30px; height: 30px; margin-left: 5px;" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useHead } from '@vueuse/head'

// SEO Meta标签配置
useHead({
  title: '华洲电力建设有限公司 - 专业电力工程建设解决方案',
  meta: [
    {
      name: 'description',
      content: '华洲电力建设有限公司专注于电力工程建设、设计与运维，为客户提供全方位的电力解决方案，以专业技术和卓越服务赢得行业赞誉。'
    },
    {
      name: 'keywords',
      content: '电力工程建设,输变电工程,电力施工,电力工程设计,华洲电力,电力解决方案'
    },
    {
      name: 'author',
      content: '华洲电力建设有限公司'
    },
    {
      property: 'og:title',
      content: '华洲电力建设有限公司 - 专业电力工程建设解决方案'
    },
    {
      property: 'og:description',
      content: '华洲电力建设有限公司专注于电力工程建设、设计与运维，为客户提供全方位的电力解决方案，以专业技术和卓越服务赢得行业赞誉。'
    },
    {
      property: 'og:type',
      content: 'website'
    }
  ]
})

// 页面滚动处理
const currentPage = ref(0)
const pageCount = 5 // 总页数
const selectedIndex = ref('1')

// 根据选中的索引动态计算背景图片
const currentBackgroundImage = computed(() => {
  const imageMap = {
    '1': require('@/assets/anli1.jpg'),
    '2': require('@/assets/anli2.jpg'),
    '3': require('@/assets/anli4.jpg'),
    '4': require('@/assets/anli3.jpg')
  }
  return imageMap[selectedIndex.value] || require('@/assets/anli1.jpg')
})

const handleSelect = (key, keyPath) => {
  selectedIndex.value = key
}

// 监听滚动事件，实现页面翻页效果
const handleScroll = (event) => {
  // 阻止默认的滚动行为
  event.preventDefault()
  
  // 获取滚动方向
  const delta = Math.sign(event.deltaY)
  
  // 更新当前页码
  const newPage = currentPage.value + delta
  
  // 检查页码是否有效
  if (newPage >= 0 && newPage < pageCount) {
    currentPage.value = newPage
    scrollToPage(newPage)
  }
}

// 滚动到指定页面
const scrollToPage = (pageIndex) => {
  const sections = document.querySelectorAll('.page-section')
  if (sections[pageIndex]) {
    sections[pageIndex].scrollIntoView({ behavior: 'smooth' })
  }
}

// 点击导航栏滚动到对应页面
const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId)
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' })
    
    // 更新当前页码
    const sections = document.querySelectorAll('.page-section')
    sections.forEach((section, index) => {
      if (section.id === sectionId) {
        currentPage.value = index
      }
    })
  }
}

// 页面加载时的初始化
onMounted(() => {
  // 添加鼠标滚轮事件监听
  document.addEventListener('wheel', handleScroll, { passive: false })
  
  // 监听页面滚动，更新当前页码
  window.addEventListener('scroll', () => {
    const sections = document.querySelectorAll('.page-section')
    const scrollPosition = window.scrollY + window.innerHeight / 3
    
    sections.forEach((section, index) => {
      const sectionTop = section.offsetTop
      const sectionBottom = sectionTop + section.offsetHeight
      
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        currentPage.value = index
      }
    })
  })
})

// 组件卸载时移除事件监听
onUnmounted(() => {
  document.removeEventListener('wheel', handleScroll)
})
</script>

<style lang="scss" scoped>
/* 关于我们部分样式 */
.about-section {
  padding: 10px 0;
  background-color: #ffffff;
}

.about-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1600px;
  margin: 0 auto;
}

.about-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.about-text p {
  font-size: 13px;
  line-height: 1.5;
  color: #333;
}

/* 统计数据样式 */
.stats-container {
  display: flex;
  gap: 40px;
  margin: 5px 0;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-number {
  font-size: 24px;
  font-weight: 500;
  color: #0066cc;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
  text-align: center;
}

/* 了解更多链接样式 */
.learn-more-link {
  display: inline-block;
  color: #0066cc;
  text-decoration: none;
  font-weight: 500;
  margin-top: 5px;
  transition: color 0.3s ease;
  z-index: 2;
}

.learn-more-l12nk:hover {
  color: #004d99;
  text-decoration: underline;
}

/* 右侧图片样式 */
.about-image {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  position: relative;
}
.about-image img {
  width: 100%;
  height: auto;
  max-width: 900px;
  object-fit: cover;
}/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  overflow-x: hidden;
}

/* 首页容器 */
.home-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.contact-info {
  font-size: 14px;
  color: #666;
}

/* 页面部分通用样式 */
.page-section {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
}

/* 英雄区域样式 */
.hero-section {
  background-color: #000;
}

.home-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/home_bg.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.home-bg::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.content-overlay {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 10;
  color: white;
  padding: 0 20px;
}

.title-section {
  margin-bottom: 30px;
}

.title-section h1 {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.title-section h2 {
  font-size: 1.8rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.intro-section {
  max-width: 800px;
  margin-bottom: 40px;
}

.intro-section p {
  font-size: 1.1rem;
  line-height: 1.6;
  padding: 20px;
  border-radius: 8px;
}

.buttons-section {
  display: flex;
  gap: 16px;
}

.action-button {
  height: 40px;
  padding: 0 24px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 3px;
  color: white;
}

.custom-primary-btn {
  --el-button-bg-color: #3f5ff0;
  --el-button-border-color: #3f5ff0;
  --el-button-hover-bg-color: #2d4adf;
  --el-button-hover-border-color: #2d4adf;
  --el-button-active-bg-color: #2541bf;
  --el-button-active-border-color: #2541bf;
  --el-button-text-color: white;
  --el-button-hover-text-color: white;
  --el-button-active-text-color: white;
}

/* 通用区块标题样式 */
.section-header {
  text-align: left;
  margin-right: 20px;
  margin-top: -40px;
  margin-bottom: 20px;
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
  position: relative;
}

.section-header p {
  font-size: 12px;
  color: #807e7e;
  margin-top: 5px;
  position: relative;
}

.header-line {
  width: 80px;
  height: 3px;
  background-color: #3f5ff0;
  margin: 0;
}
.white-line {
  width: 80px;
  height: 3px;
  background-color: #f0f0f0;
  margin: 0;
}
/* 区块内容容器 */
.section-content {
  max-width: 1600px;
  width: 100%;
  padding: 0 70px 0 70px;
  margin: 0 auto;
}
.section-content-bussiness {
  width: 100%;
  height: 100%;
}
/* 公司简介区块 */
.about-section {
  background-color: #f9f9f9;
}

.about-content {
  display: flex;
  gap: 20px;
  align-items: center;
}

.company-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 30px;
}

.info-item {
  min-width: 200px;
}

.info-label {
  font-weight: 500;
  color: #333;
  margin-right: 10px;
}

.info-value {
  color: #666;
}

/* 主营业务区块 */
.business-section {
  background-color: #fff;
}

.business-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.business-card {
  background-color: #f8f9fa;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.business-card h3 {
  font-size: 1.3rem;
  color: #333;
  margin-bottom: 15px;
}

.business-card p {
  color: #666;
  line-height: 1.6;
}

/* 工程案例区块 */
.cases-section {
  background-color: #f0f2f5;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-bottom: 40px;
}

.case-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.case-item:hover {
  transform: translateY(-5px);
}

.case-image {
  height: 200px;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.case-item:hover .case-image img {
  transform: scale(1.05);
}

.case-info {
  padding: 15px;
  text-align: center;
}

.case-info h3 {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 5px;
}

.case-info p {
  font-size: 0.9rem;
  color: #666;
}

.case-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.page-btn {
  padding: 8px 20px;
  background-color: #3f5ff0;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.page-btn:hover {
  background-color: #2d4adf;
}

/* 关于我们区块 */
.contact-section {
  background-color: #fff;
}

.contact-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.contact-info h3,
.partner-logos h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.contact-info p {
  margin-bottom: 10px;
  color: #666;
  text-align: center;
}

.contact-stats {
  display: flex;
  gap: 50px;
  margin: 20px 0;
}

.stat-item {
  text-align: center;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
}

.partner-logos {
  text-align: center;
}

.logos-container {
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: center;
}

.logos-container img {
  max-height: 80px;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.logos-container img:hover {
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  
  /* 英雄区域响应式 */
  .title-section h1 {
    font-size: 2rem;
  }
  
  .title-section h2 {
    font-size: 1.3rem;
  }
  
  .intro-section p {
    font-size: 1rem;
    padding: 15px;
  }
  
  .buttons-section {
    flex-direction: column;
    gap: 15px;
  }
  
  .action-button {
    width: 100%;
    max-width: 300px;
  }
  
  /* 公司简介响应式 */
  .about-content {
    flex-direction: column;
    gap: 20px;
  }
  
  .company-info {
    justify-content: center;
  }
  
  /* 主营业务响应式 */
  .business-cards {
    grid-template-columns: 1fr;
  }
  
  /* 工程案例响应式 */
  .cases-grid {
    grid-template-columns: 1fr;
  }
  
  /* 关于我们响应式 */
  .contact-stats {
    flex-direction: column;
    gap: 30px;
  }
  
  .logos-container {
    flex-direction: column;
    gap: 30px;
  }
}
</style>